// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/tickets/tickets.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca). Se han quitado las columnas auxiliares (*Id, *Utc): el
// backend las devuelve siempre y la pantalla las usa, pero no se eligen.

export const COLUMNAS_TICKETS = [
  {
    id: 'id',
    label: 'Ticket',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Ticket',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'General',
  },
  { id: 'asunto', label: 'Asunto', width: 280, sortable: true, filter: 'text', group: 'Ticket' },
  {
    id: 'solicitante',
    label: 'Solicitante',
    width: 170,
    sortable: true,
    filter: 'text',
    group: 'Solicitante',
  },
  {
    id: 'solicitanteEmail',
    label: 'Email solicitante',
    width: 220,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Solicitante',
  },
  { id: 'estado', label: 'Estado', width: 130, sortable: true, filter: 'multi', group: 'Gestión' },
  {
    id: 'prioridad',
    label: 'Prioridad',
    width: 110,
    sortable: true,
    filter: 'multi',
    group: 'Gestión',
  },
  { id: 'agente', label: 'Agente', width: 160, sortable: true, filter: 'multi', group: 'Gestión' },
  {
    id: 'grupo',
    label: 'Grupo',
    width: 140,
    sortable: true,
    filter: 'multi',
    group: 'Gestión',
  },
  { id: 'tema', label: 'Tema', width: 140, sortable: true, filter: 'multi', group: 'Gestión' },
  {
    id: 'canal',
    label: 'Canal',
    width: 110,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Gestión',
  },
  {
    id: 'comentarios',
    label: 'Comentarios',
    width: 120,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Hilo',
  },
  {
    id: 'adjuntos',
    label: 'Adjuntos',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Hilo',
  },
  {
    id: 'ultimoComentario',
    label: 'Último comentario',
    width: 320,
    sortable: true,
    filter: 'text',
    group: 'Hilo',
  },
  {
    id: 'ultimoAutor',
    label: 'Autor último comentario',
    width: 180,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Hilo',
  },
  {
    id: 'creado',
    label: 'Creado',
    width: 130,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'actualizado',
    label: 'Actualizado',
    width: 130,
    sortable: true,
    filter: 'date',
    group: 'Fechas',
    hora: true,
  },
  {
    id: 'venceSla',
    label: 'Vence SLA',
    width: 130,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
    hora: true,
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_TICKETS = 'tickets';
